import { render, staticRenderFns } from "./FullscreenModal.vue?vue&type=template&id=2feba41e&scoped=true&"
import script from "./FullscreenModal.vue?vue&type=script&lang=js&"
export * from "./FullscreenModal.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenModal.vue?vue&type=style&index=0&id=2feba41e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feba41e",
  null
  
)

export default component.exports